function handleRequestEvents(requestEvents, graphFlowId) {
  requestEvents.forEach(function (event) {
    var _a, _b, _c;

    switch (event.__typename) {
      case 'EntityCreatedPathGraphFlowRequestEvent':
        (_a = window.tracking) === null || _a === void 0 ? void 0 : _a.events.trackPathClientFlowEntityCreated({
          path_graph_flow_id: graphFlowId,
          entity_created_id: event.entityCreatedId,
          entity_created_type: event.entityCreatedType
        });
        /**
         * If an expert application was created, track the submission here. This event includes slug
         * since it directly maps to Facebook's SubmitApplication event we use.
         */

        if (event.createdExpertApplication) {
          (_b = window.tracking) === null || _b === void 0 ? void 0 : _b.events.trackExpertApplicationSubmitted({
            category: event.createdExpertApplication.category.slug
          });
        }

        break;

      case 'PathCompletedPathGraphFlowRequestEvent':
        (_c = window.tracking) === null || _c === void 0 ? void 0 : _c.events.trackPathClientFlowCompleted({
          path_graph_flow_id: graphFlowId,
          nodes: event.nodeReferences
        });
        break;
    }
  });
}

export default handleRequestEvents;
//# sourceMappingURL=handleRequestEvents.js.map
